import { createSlice } from "@reduxjs/toolkit";
import { getTeamsDraftRoom, fetchFirstPlayersForTeams,
    preloadPlayersForTeams, draftUserTeamPlayer} from "./stimulyatorDraftRoomAction";

const initialState = {
    teams: [],
    teamDraftPlayerChoose: [],
    chosenPlayerIds: [],
    round: 1,
    totalRounds: 7,
    chosenTeam: null,
    isPausedForUserPick: false,
    playerCache: {},
    loading: false,
};

export const stimulyatorDraftRoomSlice = createSlice({
    name: "stimulyatorDraftRoom",
    initialState,
    reducers: {
        setRound: (state, action) => {
            state.round = action.payload;
        },
        setTotalRounds: (state, action) => {
            state.totalRounds = action.payload;
        },
        setChosenTeam: (state, action) => {
            state.chosenTeam = action.payload;
        },
        setPausedForUserPick: (state, action) => {
            state.isPausedForUserPick = action.payload;
        },
        clearStimulyatorData: (state) => {
            state.teams = [];
            state.teamDraftPlayerChoose = [];
            state.chosenPlayerIds = [];
            state.round = 1;
            state.playerCache = {};
            state.isPausedForUserPick = false;
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTeamsDraftRoom.pending, (state) => {
                state.loading = true;
            })
            .addCase(getTeamsDraftRoom.fulfilled, (state, action) => {
                state.loading = false;
                state.teams = action.payload.teamSet;
                state.teamDraftPlayerChoose = action.payload.updatedTeams;
            })
            .addCase(getTeamsDraftRoom.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchFirstPlayersForTeams.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchFirstPlayersForTeams.fulfilled, (state, action) => {
                state.loading = false;
                const updatedTeam = action.payload;
                const { teamId, teamName, players, choosePlayers } = updatedTeam;
                if (!state.playerCache) state.playerCache = {};
                if (teamName && players && !state.playerCache[teamName]) {
                    state.playerCache[teamName] = players;
                }
                const index = state.teamDraftPlayerChoose.findIndex(t => t.id === teamId);
                if (index !== -1) {
                    const player = choosePlayers?.[0];
                    if (player) {
                        state.teamDraftPlayerChoose[index].choosePlayers.push(player);
                        if (!state.chosenPlayerIds.includes(player.id)) {
                            state.chosenPlayerIds.push(player.id);
                        }
                    }
                }
                const allTeamsPicked = state.teamDraftPlayerChoose.every(
                    t => t.choosePlayers.length >= state.round
                );
                if (allTeamsPicked && state.round < state.totalRounds) {
                    state.round += 1;
                }
            })
            .addCase(fetchFirstPlayersForTeams.rejected, (state) => {
                state.loading = false;
            })
            .addCase(preloadPlayersForTeams.fulfilled, (state, action) => {
                // ✅ Store all preloaded players in cache
                state.playerCache = { ...state.playerCache, ...action.payload };
                state.loading = false;
            })
            .addCase(preloadPlayersForTeams.pending, (state) => {
                state.loading = true;
            })
            .addCase(preloadPlayersForTeams.rejected, (state) => {
                state.loading = false;
            })
            .addCase(draftUserTeamPlayer.fulfilled, (state, action) => {
                if (!action.payload) return;
                const { updatedTeams, updatedChosenIds, nextRound } = action.payload;

                state.teamDraftPlayerChoose = updatedTeams;
                state.chosenPlayerIds = updatedChosenIds;
                state.round = nextRound;
                state.isPausedForUserPick = false; // ✅ Resume simulation
            })
            .addCase(draftUserTeamPlayer.pending, (state) => {
                state.loading = true;
            })
            .addCase(draftUserTeamPlayer.rejected, (state, action) => {
                state.loading = false;
            });
    },
});


export const {
    setRound,
    setChosenTeam,
    clearStimulyatorData,
    setTotalRounds,
    setPausedForUserPick
} = stimulyatorDraftRoomSlice.actions;

export const selectStimulyatorDrafRoom = (state) => state.stimulyatorDraftRoom;

export default stimulyatorDraftRoomSlice.reducer;


